/******************************************
*  Author : Riccardo Di Dato   
*  Created On : Wed Sep 28 2022
*  File : Types.ts
*******************************************/

import { NotificationDeviceType } from "@api-commons/api/types/SubscriptionTypes.js";
import { AuthProviderIdentifier } from "../login/AuthProviderIdentifier.js";
import { MembershipType } from "@api-commons/membership/MembershipController.js";

export enum CTA_NAME {
    LOGIN = "login",
    LOGIN_MULTI = "login_multi",
    APP_OPEN_INST = "app_open_inst",
    APP_INST = "app_inst",
    APP_OPEN = "app_open",
    PERSONAL_DATA = "personal_data",
    SUBSCRIBE = "subscribe",
    NEWSLETTER_SUBSCRIBE = "newsletter_subscribe",
    PUSH_CHECK = "push_check",
    FOLLOW = "follow",
    LOGIN_REQUIRED_DIALOG = "login_required_dialog",
    EMAIL_LOGIN_REQUIRED_DIALOG = "email_login_required_dialog",
    EMAIL_FIX_REQUIRED_DIALOG = "email_fix_required_dialog",
    MEMBERSHIP_REQUIRED_DIALOG = "membership_required_dialog",
}

export enum CTA_OUTCOME {
    SHOWN = "IMPRESSION",
    COMPLETED = "CLICK",
    DISMISSED = "DISMISS",
}
export type SOURCE_ELEMENT = string;
export interface CTAStatsDetails {
    action: CTA_NAME;
    outcome: CTA_OUTCOME;
    source_element: SOURCE_ELEMENT;
    provider?: AuthProviderIdentifier;
    device_type?: NotificationDeviceType;
    topic?: string;
    url?: string;   
    membership_type?: MembershipType;
}



